import "core-js/modules/es6.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibOverallExperience',
  props: {
    services: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      modals: [],
      modalWarning: false
    };
  },
  computed: {
    themeStyle: function themeStyle() {
      return {
        color: this.$store.getters['theme/theme'].primaryColor
      };
    },
    answers: function answers() {
      return this.$store.getters['answers/responses'] || {};
    }
  },
  methods: {
    handleResponse: function handleResponse(value, id) {
      this.$store.dispatch('answers/setResponse', {
        value: value,
        id: id
      });
    },
    openModal: function openModal(item) {
      this.activeService = item.id;
      this.$set(this.modals, item.id, true);
    },
    getActive: function getActive(service) {
      var _this = this;

      var active = false;

      if (service.subQuestions) {
        service.subQuestions.forEach(function (subQuestion) {
          if (_this.answers[subQuestion.id]) {
            active = true;
          }
        });
      }

      return active;
    },
    getDisabled: function getDisabled(item) {
      var _this2 = this;

      var disabled = false;

      if (item.subQuestions) {
        item.subQuestions.forEach(function (subQuestion) {
          if (subQuestion.required) {
            var answer = _this2.answers[subQuestion.id];

            if (!answer) {
              disabled = true;
            }

            if (Array.isArray(answer) && !answer.length) {
              disabled = true;
            }
          }
        });
      }

      return disabled;
    },
    closeModal: function closeModal(item, check) {
      var dirty = this.isDirty(item);

      if (check && dirty) {
        this.modalWarning = true;
        return;
      }

      this.$set(this.modals, item.id, false);
    },
    closeWithoutSave: function closeWithoutSave() {
      var _this3 = this;

      var item = this.services.find(function (i) {
        return i.id === _this3.activeService;
      });
      this.clear(item);
      this.closeModal(item, false);
      this.modalWarning = false;
    },
    isDirty: function isDirty(item) {
      var _this4 = this;

      var subQuestions = item.subQuestions;
      var dirty = false;

      if (subQuestions) {
        subQuestions.forEach(function (subQuestion) {
          if (_this4.answers[subQuestion.id]) {
            dirty = true;
          }
        });
      }

      return dirty;
    },
    clear: function clear(item) {
      var _this5 = this;

      var subQuestions = item.subQuestions;

      if (subQuestions) {
        subQuestions.forEach(function (subQuestion) {
          return _this5.handleResponse(null, subQuestion.id);
        });
      }
    }
  }
};